import {
  GET_BLOCKLIST,
  GET_BLOCKLIST_INDEX,
  ADD_BLOCKLIST_ENTRY,
  REMOVE_BLOCKLIST_ENTRY,
  LOOKUP_BLOCKLIST_NUMBER,
  UPDATE_BLOCKLIST_SETTINGS
} from './constant';

/* ------------------------------------------------------------------ list */

export function getBlocklistRequest(data) {
  return {
    type: GET_BLOCKLIST.PENDING,
    data
  };
}

export function getBlocklistSuccess(data) {
  return {
    type: GET_BLOCKLIST.SUCCESS,
    data
  };
}

export function getBlocklistError(err) {
  return {
    type: GET_BLOCKLIST.ERROR,
    err
  };
}

/* ------------------------------------------------------------------- add */

export function addBlocklistEntryRequest(data) {
  return {
    type: ADD_BLOCKLIST_ENTRY.PENDING,
    data
  };
}

export function addBlocklistEntrySuccess(data) {
  return {
    type: ADD_BLOCKLIST_ENTRY.SUCCESS,
    data
  };
}

export function addBlocklistEntryError(err) {
  return {
    type: ADD_BLOCKLIST_ENTRY.ERROR,
    err
  };
}

/* ---------------------------------------------------------------- remove */

export function removeBlocklistEntryRequest(data) {
  return {
    type: REMOVE_BLOCKLIST_ENTRY.PENDING,
    data
  };
}

export function removeBlocklistEntrySuccess(data) {
  return {
    type: REMOVE_BLOCKLIST_ENTRY.SUCCESS,
    data
  };
}

export function removeBlocklistEntryError(err) {
  return {
    type: REMOVE_BLOCKLIST_ENTRY.ERROR,
    err
  };
}

/* ---------------------------------------------------------------- lookup */

export function lookupNumberRequest(data) {
  return {
    type: LOOKUP_BLOCKLIST_NUMBER.PENDING,
    data
  };
}

export function lookupNumberSuccess(data) {
  return {
    type: LOOKUP_BLOCKLIST_NUMBER.SUCCESS,
    data
  };
}

export function lookupNumberError(err) {
  return {
    type: LOOKUP_BLOCKLIST_NUMBER.ERROR,
    err
  };
}

/* ----------------------------------------------------------------- index */

/**
 * Loads every active entry once so the visitors table can show Block or Allow
 * per row by matching locally, instead of one lookup call per visible row.
 */
export function getBlocklistIndexRequest() {
  return { type: GET_BLOCKLIST_INDEX.PENDING };
}

export function getBlocklistIndexSuccess(data) {
  return {
    type: GET_BLOCKLIST_INDEX.SUCCESS,
    data
  };
}

export function getBlocklistIndexError(err) {
  return {
    type: GET_BLOCKLIST_INDEX.ERROR,
    err
  };
}

/* --------------------------------------------------------------- settings */

/**
 * Saves the building's blocklist settings. `data` carries only the fields the
 * admin actually changed — an omitted field is left as it is server-side.
 */
export function updateBlocklistSettingsRequest(data) {
  return {
    type: UPDATE_BLOCKLIST_SETTINGS.PENDING,
    data
  };
}

export function updateBlocklistSettingsSuccess(data) {
  return {
    type: UPDATE_BLOCKLIST_SETTINGS.SUCCESS,
    data
  };
}

export function updateBlocklistSettingsError(err) {
  return {
    type: UPDATE_BLOCKLIST_SETTINGS.ERROR,
    err
  };
}

/* --------------------------------------------------------------- confirm */

/** Confirm before adding a block. `payload` is the add-entry form's values. */
export function openBlockConfirm(payload) {
  return {
    type: 'BLOCKLIST_CONFIRM_OPEN',
    data: {
      mode: 'block',
      phone: payload.phone,
      name: payload.name,
      payload
    }
  };
}

/** Confirm before lifting a block. */
export function openAllowConfirm(data) {
  return {
    type: 'BLOCKLIST_CONFIRM_OPEN',
    data: {
      mode: 'allow',
      phone: data.phone,
      name: data.name,
      entryId: data.entryId
    }
  };
}

export function closeConfirm() {
  return { type: 'BLOCKLIST_CONFIRM_CLOSE' };
}

/* ------------------------------------------------------ local ui actions */

/**
 * Opens the add-entry modal. `phone` pre-fills the number and runs the lookup
 * automatically when the modal is opened from a visitor row or record;
 * `visitorRecordId` links the entry to the visit that triggered the block.
 */
export function openAddEntryModal(data) {
  return {
    type: 'BLOCKLIST_ADD_MODAL_OPEN',
    data: data || {}
  };
}

export function closeAddEntryModal() {
  return { type: 'BLOCKLIST_ADD_MODAL_CLOSE' };
}

export function resetLookup() {
  return { type: 'BLOCKLIST_LOOKUP_RESET' };
}

export function clearAddError() {
  return { type: 'BLOCKLIST_ADD_ERROR_CLEAR' };
}

/** Reads blocklist settings off the building cached at login / building select. */
export function loadBlocklistSettings() {
  return { type: 'BLOCKLIST_SETTINGS_LOAD' };
}
